import React from "react";
import remove_icon from "../../assets/images/icon-remove.svg";
import Select from "react-select";
import useAuth from "../../hooks/useAuth";

export const SearchMember: React.FC<any> = (props) => {
  const {
    client = [],
    role = [],
    type = [],
    clientList = [],
    roleList = [],
    typeList = [],
    handleClient,
    handleRole,
    handleType,
  } = props.data;

  const { user } = useAuth() as any;

  return (
    <div className="search-component">
      <div className="container uk-container-large">
        {/* <div className="label title-label fw-bold mb-4">
          Which artist are you looking for?
        </div> */}
        <div className="search-content row d-flex flex-row position-relative">
          <div className="col-md-6 search-item-title member title-label fw-bold">My Artists</div>
          {/* <div className="col-md-2 search-item">
            <div className="item-header">
              <div className="text-white item-title">Name</div>
              <div className="count-found">found {clientList.length}</div>
            </div>
            <div
              className="d-flex flex-row justify-content-between align-items-center"
              style={{ width: "100%" }}
            >
              <Select
                className="select-search"
                options={
                  clientList?.map((item: any) => ({
                      value: item.id,
                      label: item.title
                  }))
                }
                onChange={(item: any) =>
                  {
                    if((user?.profile?.client_id===null&&+item.value===2)||(user?.profile?.client_id==+item.value)){
                    // if(+item.value===2){
                      // handleClient(+item.value)
                    }else{
                      alert("Please contact Cugate Ltd. for access permissions.");
                    }
                  }
                }
                placeholder=""
                isSearchable={true}
              />
            </div>
            <div className="d-flex flex-row flex-wrap mt-2">
              {client?.map((item: any) => (
                <div
                  className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                  key={"client_" + item}
                  // onClick={() => handleClient(item)}
                >
                  <div className="me-2 title">{clientList.filter((c: any)=>c.id===item).length?clientList.filter((c: any)=>c.id===item)[0].title:''}</div>
                    <img alt="remove" className="remove-selected" src={remove_icon}/>
                </div>
              ))}
            </div>
          </div>  */}
          <div className="col-md-2 search-item">
            <div className="item-header">
              <div className="text-white item-title">Role</div>
              <div className="count-found">found 3</div>
            </div>
            <div
              className="d-flex flex-row justify-content-between align-items-center"
              style={{ width: "100%" }}
            >
              <Select
                className="select-search"
                options={
                  // roleList.filter((item: any) => [13, 33, 43].includes(item.id))?.map((a:any)=>({
                  roleList?.map((a: any) => ({
                    value: a.id,
                    label: a.title
                  }))
                }
                onChange={(item: any) =>
                  handleRole(+item.value)
                }
                placeholder=""
                isSearchable={true}
              />
            </div>
            <div className="d-flex flex-row flex-wrap mt-2">
              {role?.map((item: any) => (
                <div
                  className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                  key={"role_" + item}
                  onClick={() => handleRole(item)}
                >
                  <div className="me-2 title">{roleList.filter((c: any) => c.id === item).length ? roleList.filter((c: any) => c.id === item)[0].title : ''}</div>
                  <img
                    alt="remove"
                    className="remove-selected"
                    src={remove_icon}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-2 search-item">
            <div className="item-header">
              <div className="text-white item-title">Type</div>
              <div className="count-found">found {typeList.length}</div>
            </div>
            <div
              className="d-flex flex-row justify-content-between align-items-center"
              style={{ width: "100%" }}
            >
              <Select
                className="select-search"
                options={
                  typeList?.map((a: any) => ({
                    value: a.id,
                    label: a.title
                  }))
                }
                onChange={(item: any) =>
                  handleType(+item.value)
                }
                placeholder=""
                isSearchable={true}
              />
            </div>
            <div className="d-flex flex-row flex-wrap mt-2">
              {type?.map((item: any) => (
                <div
                  className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                  key={"type_" + item}
                  onClick={() => handleType(item)}
                >
                  <div className="me-2 title">{typeList.filter((c: any) => c.id === item).length ? typeList.filter((c: any) => c.id === item)[0].title : ''}</div>
                  <img
                    alt="remove"
                    className="remove-selected"
                    src={remove_icon}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchMember;
